import { Component, Input, OnInit } from '@angular/core';
import { LevelMoveOrderReview } from 'store/level-move/models/order-review';
import { PlanSwitchOrderReview } from 'store/plan-eligibility/models/order-review';

@Component({
    selector: 'xm-estimated-monthly-bill',
    styleUrls: ['./estimated-monthly-bill.scss'],
    templateUrl: './estimated-monthly-bill.html',
    standalone: false
})
export class XmEstimatedMonthlyBillComponent implements OnInit {
    @Input() public expandIconOptions: MediaImageOptions;
    @Input() public cmsData: PlanSwitchOrderReview | LevelMoveOrderReview;

    public btgExpandFlag: boolean = false;
    public tabletExpandFlag: boolean = false;
    public unlimitedExpandFlag: boolean = false;
    public monthlyBillExpandFlag: boolean = false;
    public planSwitchData: LevelMoveEstimatedMonthlyBill;
    public unlimitedPlanGroup: LevelMoveDataPlanGroup;
    public byTheGigPlanGroup: LevelMoveDataPlanGroup;
    public tabletPlanGroup: LevelMoveDataPlanGroup;
    public serviceAndDevices: LevelMoveServicesAndDevices;
    public lineExpandFlags: boolean[];
    public smartWatchPlanGroup: LevelMoveDataPlanGroup;
    public smartWatchExpandFlag: boolean = false;

    public ngOnInit(): void {
        this.planSwitchData = this.cmsData.orderSummary.summaries.estimatedMonthlyBill;
        this.unlimitedPlanGroup = this.cmsData.monthlyUnlimitedPlanGroup;  
        this.byTheGigPlanGroup = this.cmsData.monthlyByTheGigPlanGroup;
        this.tabletPlanGroup = this.cmsData.monthlyTabletPlanGroup;
        this.smartWatchPlanGroup = this.cmsData.monthlySmartWatchPlanGroup;
        this.serviceAndDevices = this.planSwitchData.servicesAndDevices;
        this.buildProps();
    }

    public formatBodyContent(bodyContent?: string): string[] {
        return bodyContent ? bodyContent.split(/\\n|\r?\n/) : [];
    }

    private buildProps(): void {
        this.lineExpandFlags = this.serviceAndDevices.devices.map(() => false);
    }

}
